import {BitmapText} from "pixi.js";
import Spine = PIXI.spine.Spine;
import {SpineTween} from "@nolimit/slot-game/bin/animation/SpineTween";
import {FireInTheHole2} from "../../FireInTheHole2";
import {FITH2FontConfig} from "../../configs/FITH2FontConfig";
export class ICart extends PIXI.Sprite {
    //protected _spine: Spine | null;
    protected _spine: BitmapText | null;
    protected _id: number;
    protected _name: string;
    protected _isActive: boolean = false;

    constructor(id: number, name: string, container: PIXI.Container) {
        super();
        this.name = `cart${id}-${name}`;
        this._id = id;
        this._name = name;
        this.anchor.set(0, 0);

        //this._spine = new Spine(FireInTheHole2.assetLoader.getSpineAsset(name));
        //this.addChild(this._spine);
        this._spine = new BitmapText(name, FITH2FontConfig.FS_COIN_MULTI);
        this.addChild(this._spine);
        container.addChild(this);
    }

    private destroySpine(): void {
        if (this._spine) {
            this._spine.destroy();
            this._spine = null;
        }
    }

    public reset() {
        this._isActive = false;
        this.visible = false;
        this.destroySpine();
    }
}